import type { EventPayload } from '@side/analytics';

export enum TrackCommunityEvent {
  PromotionCardFieldBlur,
  PromotionCardDisableEnable,
  OptInOutButtonClick,
  ExploreButtonClick,
  PromotionCardExpandCollapse,
  DocumentsPromotionBannerView,
  DocumentsPromotionBannerClick,
  DocumentsPromotionBannerClose,
  FeedbackProgramSignUpClick,
  StatusChangedBannerView,
  StatusChangedBannerClose,
  AddListingPrice,
  SideListingsCardClick,
  CommunityLanding,
  CommunityListingsSearch,
  CommunityLandingModalGoBack,
  CommunityLandingModalCheckbox,
  CommunityLandingModalAccept,
  CommunityLandingModalMount,
  CommunityLandingPartnerMapClick,
  CommunityListingPageLoad,
  BackToCommunityClick,
  SortCommunityListings,
  CommunityDetailsClick,
  CommunityDetailsMount,
  CommunityDetailsUnmount,
  CommunityDetailsCopyValueClick,
  CommunityDetailsMailToClick,
  CommunityDetailsCallClick,
  CommunityListingsPerPageChange,
  CommunityListingsPaginationClick,
  CommunityListingsApplyFilters,
  CommunityListingsLocationError,
  CommunityListingsLocationSelect,
  CommunityListingsFilterButtonClick,
  CommunityListingsFilterModalMount,
  CommunityListingsFilterModalUnmount,
  CommunityListingsDistanceSelect,
  CommunityListingsClearFilters,
  CommunityListingsRemoveButtonClick,
  PartnerMapLanding,
  PartnerMapDrag,
  PartnerMapZoomChange,
  PartnerMapListMapToggleClick,
  PartnerMapNearbyTeamsClick,
  PartnerMapTeamDetailsActionButtonClick,
  PartnerMapTeamDetailsClose,
  PartnerMapSelectSearchDropdownOption,
  PartnerMapTeamDetailsCopy,
  PartnerMapPinHover,
  PartnerMapTeamSelection,
  PartnerMapDataFetch,
  PartnerMapTeamDetailsAccountSettingsClick,
  PartnerMapTeamDetailsViewAllLocationsClick,
  PartnerMapMobileGroupTooltipLoad,
  PartnerMapMobileGroupTooltipPaginatePreviousClick,
  PartnerMapMobileGroupTooltipPaginateNextClick,
  PartnerMapViewAllLocationsDropdownClick,
}

type EventTypeLabels = Record<TrackCommunityEvent, string>;

export const CommunityEventLabels: EventTypeLabels = {
  [TrackCommunityEvent.PromotionCardFieldBlur]: 'COVERSHEET',
  [TrackCommunityEvent.PromotionCardDisableEnable]: 'COVERSHEET',
  [TrackCommunityEvent.ExploreButtonClick]: 'COVERSHEET',
  [TrackCommunityEvent.OptInOutButtonClick]: 'COVERSHEET',
  [TrackCommunityEvent.PromotionCardExpandCollapse]: 'COVERSHEET',
  [TrackCommunityEvent.DocumentsPromotionBannerView]: 'DOCUMENTS',
  [TrackCommunityEvent.DocumentsPromotionBannerClick]: 'DOCUMENTS',
  [TrackCommunityEvent.DocumentsPromotionBannerClose]: 'DOCUMENTS',
  [TrackCommunityEvent.FeedbackProgramSignUpClick]: 'COMMUNITY',
  [TrackCommunityEvent.StatusChangedBannerView]: 'COVERSHEET',
  [TrackCommunityEvent.StatusChangedBannerClose]: 'COVERSHEET',
  [TrackCommunityEvent.AddListingPrice]: 'COVERSHEET',
  [TrackCommunityEvent.SideListingsCardClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLanding]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsSearch]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLandingModalGoBack]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLandingModalCheckbox]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLandingModalAccept]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLandingModalMount]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingPageLoad]: 'COMMUNITY',
  [TrackCommunityEvent.BackToCommunityClick]: 'COMMUNITY',
  [TrackCommunityEvent.SortCommunityListings]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsMount]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsUnmount]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsCopyValueClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsMailToClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityDetailsCallClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsPerPageChange]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsPaginationClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsApplyFilters]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsLocationError]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsLocationSelect]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsFilterButtonClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsFilterModalMount]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsFilterModalUnmount]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsDistanceSelect]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsClearFilters]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityListingsRemoveButtonClick]: 'COMMUNITY',
  [TrackCommunityEvent.CommunityLandingPartnerMapClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapLanding]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapDrag]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapZoomChange]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapListMapToggleClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapNearbyTeamsClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamDetailsActionButtonClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamDetailsClose]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapSelectSearchDropdownOption]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamDetailsCopy]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapPinHover]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamSelection]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapDataFetch]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamDetailsAccountSettingsClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapTeamDetailsViewAllLocationsClick]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipLoad]: 'COMMUNITY',
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipPaginatePreviousClick]:
    'COMMUNITY',
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipPaginateNextClick]:
    'COMMUNITY',
  [TrackCommunityEvent.PartnerMapViewAllLocationsDropdownClick]: 'COMMUNITY',
};

type EventTypePayloads = Record<TrackCommunityEvent, EventPayload>;

export const CommunityEventsMap: EventTypePayloads = {
  [TrackCommunityEvent.PromotionCardFieldBlur]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: '', // dynamic
    eventType: 'blur',
    task: '', // dynamic
  },
  [TrackCommunityEvent.PromotionCardDisableEnable]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: 'listing_promotion_card',
    eventType: 'view',
    task: 'view',
  },
  [TrackCommunityEvent.OptInOutButtonClick]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: 'listing_promotion_toggle',
    eventType: 'click',
    task: 'select', // dynamic
  },
  [TrackCommunityEvent.ExploreButtonClick]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: 'explore_feed_link',
    eventType: 'click',
    task: 'redirect',
  },
  [TrackCommunityEvent.PromotionCardExpandCollapse]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: 'listing_promotion_card_view',
    eventType: 'click',
    task: '', // dynamic
  },
  [TrackCommunityEvent.DocumentsPromotionBannerView]: {
    eventContainer: 'listing_promotion_banner',
    eventTarget: 'listing_promotion_banner',
    eventType: 'load',
    task: 'view',
  },
  [TrackCommunityEvent.DocumentsPromotionBannerClick]: {
    eventContainer: 'listing_promotion_banner',
    eventTarget: 'promote_listings_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackCommunityEvent.DocumentsPromotionBannerClose]: {
    eventContainer: 'listing_promotion_banner',
    eventTarget: 'close_button',
    eventType: 'click',
    task: 'close',
  },
  [TrackCommunityEvent.FeedbackProgramSignUpClick]: {
    eventContainer: 'user_feedback_signup_card',
    eventTarget: 'signup_button',
    task: 'redirect',
    eventType: 'click',
  },
  [TrackCommunityEvent.StatusChangedBannerView]: {
    eventContainer: 'status_change_banner',
    eventTarget: 'status_change_banner',
    task: 'load',
    eventType: 'view',
  },
  [TrackCommunityEvent.StatusChangedBannerClose]: {
    eventContainer: 'status_change_banner',
    eventTarget: 'close_button',
    task: 'close',
    eventType: 'click',
  },
  [TrackCommunityEvent.AddListingPrice]: {
    eventContainer: 'listing_promotion_card',
    eventTarget: 'add_listing_price_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackCommunityEvent.SideListingsCardClick]: {
    eventContainer: 'community_page',
    eventTarget: 'side_listings_card',
    task: 'navigate',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityLanding]: {
    eventContainer: 'community_page',
    eventTarget: 'community_page',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.CommunityListingsSearch]: {
    eventContainer: 'community_listings',
    eventTarget: 'community_listings_search',
    task: 'search',
    eventType: 'blur',
  },
  [TrackCommunityEvent.CommunityLandingModalGoBack]: {
    eventContainer: 'access_confirmation_modal',
    eventTarget: 'go_back_button',
    task: 'exit',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityLandingModalCheckbox]: {
    eventContainer: 'access_confirmation_modal',
    eventTarget: 'access_checkbox',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityLandingModalAccept]: {
    eventContainer: 'access_confirmation_modal',
    eventTarget: 'accept_button',
    task: 'accept',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityLandingModalMount]: {
    eventContainer: 'access_confirmation_modal',
    eventTarget: 'access_confirmation_modal',
    task: 'view',
    eventType: 'mount',
  },
  [TrackCommunityEvent.CommunityListingPageLoad]: {
    eventContainer: 'community_listings_page',
    eventTarget: 'community_listings_page',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.BackToCommunityClick]: {
    eventContainer: 'community_listings',
    eventTarget: 'back_to_community_button',
    task: 'exit',
    eventType: 'click',
  },
  [TrackCommunityEvent.SortCommunityListings]: {
    eventContainer: 'community_listings',
    eventTarget: '', // dynamic
    task: 'sort',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityDetailsClick]: {
    eventContainer: 'community_listings',
    eventTarget: 'listing_details_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityDetailsMount]: {
    eventContainer: 'community_listings',
    eventTarget: 'listing_details_slideout',
    task: 'view',
    eventType: 'mount',
  },
  [TrackCommunityEvent.CommunityDetailsUnmount]: {
    eventContainer: 'listing_details_slideout',
    eventTarget: '', // dynamic
    task: 'exit',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityDetailsCopyValueClick]: {
    eventContainer: 'listing_details_slideout',
    eventTarget: '', // dynamic
    task: 'copy',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityDetailsMailToClick]: {
    eventContainer: 'listing_details_slideout',
    eventTarget: 'mailto_button',
    task: 'contact',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityDetailsCallClick]: {
    eventContainer: 'listing_details_slideout',
    eventTarget: 'call_button',
    task: 'contact',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsPerPageChange]: {
    eventContainer: 'community_listings',
    eventTarget: 'row_display',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsPaginationClick]: {
    eventContainer: 'community_listings',
    eventTarget: 'paginate_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsApplyFilters]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: 'apply_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsLocationError]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: 'location_error',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.CommunityListingsFilterButtonClick]: {
    eventContainer: 'community_listings',
    eventTarget: 'filter_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsFilterModalMount]: {
    eventContainer: 'community_listings',
    eventTarget: 'feed_filter_modal',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.CommunityListingsFilterModalUnmount]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: '', // dynamic
    task: 'exit',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsLocationSelect]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: 'location',
    task: 'modify_input',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsDistanceSelect]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: 'distance',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsClearFilters]: {
    eventContainer: 'feed_filter_modal',
    eventTarget: 'clear_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityListingsRemoveButtonClick]: {
    eventContainer: 'listing_details_slideout',
    eventTarget: 'remove_from_feed_button',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.CommunityLandingPartnerMapClick]: {
    eventContainer: 'community_page',
    eventTarget: 'partner_map_card',
    task: 'navigate',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapLanding]: {
    eventContainer: 'partner_map',
    eventTarget: 'partner_map',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.PartnerMapDrag]: {
    eventContainer: 'partner_map',
    eventTarget: 'partner_map',
    task: 'drag',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapZoomChange]: {
    eventContainer: 'partner_map',
    eventTarget: 'zoom_granularity',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.PartnerMapListMapToggleClick]: {
    eventContainer: 'partner_map',
    eventTarget: '', // dynamic
    task: 'view',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapNearbyTeamsClick]: {
    eventContainer: 'partner_map',
    eventTarget: 'nearby_teams_list',
    task: '', // dynamic
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapTeamDetailsActionButtonClick]: {
    eventContainer: 'team_information_modal',
    eventTarget: '', // dynamic
    task: 'contact',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapTeamDetailsViewAllLocationsClick]: {
    eventContainer: 'team_information_modal',
    eventTarget: 'all_locations_button',
    task: 'view',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapTeamDetailsClose]: {
    eventContainer: 'team_information_modal',
    eventTarget: 'close_button',
    task: 'unmount',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapSelectSearchDropdownOption]: {
    eventContainer: 'partner_map',
    eventTarget: 'search_result',
    task: 'select',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapTeamDetailsCopy]: {
    eventContainer: 'team_information_modal',
    eventTarget: '', // dynamic
    task: 'copy',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapPinHover]: {
    eventContainer: 'partner_map',
    eventTarget: '', // dynamic
    task: 'view',
    eventType: 'hover',
  },
  [TrackCommunityEvent.PartnerMapTeamSelection]: {
    eventContainer: 'partner_map',
    eventTarget: '', // dynamic
    task: 'view',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapDataFetch]: {
    eventContainer: 'partner_map',
    eventTarget: 'data_refetch',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.PartnerMapTeamDetailsAccountSettingsClick]: {
    eventContainer: 'team_information_modal',
    eventTarget: 'account_settings_link',
    task: 'navigate',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipLoad]: {
    eventContainer: 'partner_map',
    eventTarget: 'mobile_group_tooltip',
    task: 'view',
    eventType: 'load',
  },
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipPaginatePreviousClick]: {
    eventContainer: 'partner_map',
    eventTarget: 'previous_button',
    task: 'paginate',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapMobileGroupTooltipPaginateNextClick]: {
    eventContainer: 'partner_map',
    eventTarget: 'next_button',
    task: 'paginate',
    eventType: 'click',
  },
  [TrackCommunityEvent.PartnerMapViewAllLocationsDropdownClick]: {
    eventContainer: 'partner_map',
    eventTarget: 'search_result',
    task: 'select',
    eventType: 'click',
  },
};
